import { UiService } from './ui.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import * as FileSaver from 'file-saver';

import { environment } from '@environments/environment';
import { OrderStep } from '@classes/order/orderStep';

@Injectable({
  providedIn: 'root'
})
export class OrderStepsService {
  private baseUrl: string = environment.apiUrl + 'steps';

  constructor(
    private http: HttpClient,
    private uiSrv: UiService
  ) { }


  getSignature(stepId: string): Observable<Blob> {
    const url = `${this.baseUrl}/${stepId}/signature `;

    return this.http.get(url, { observe: 'response', responseType: 'blob' })
      .pipe(map(res => this.saveFile(res)));
  }

  getPhotoStep(stepId: string): Observable<Blob> {
    const url = `${this.baseUrl}/${stepId}/photo `;

    return this.http.get(url, { observe: 'response', responseType: 'blob' })
      .pipe(map(res => this.saveFile(res)));
  }

  private saveFile(res: HttpResponse<Blob>): Blob {
    FileSaver.saveAs(res.body, res.headers.get('filename'));
    return res.body;
  }

  modifyTransportVoucher(id: string, object): Observable<OrderStep> {
    return this.http.put<OrderStep>(`${this.baseUrl}/${id}/transport-voucher`, object)
      .pipe(
        tap(orderStepFromApi => {
          orderStepFromApi = OrderStep.fromObject(orderStepFromApi);
        })
      );
  }

  patchStep(stepId: string, newInfos): Observable<OrderStep> {
    return this.http.patch<OrderStep>(`${this.baseUrl}/${stepId}`, newInfos)
      .pipe(
        tap(stepFromApi => {
          stepFromApi = OrderStep.fromObject(stepFromApi);
          this.uiSrv.showSnackbar('Infos d\'étape modifiée avec succès', false);
        })
      );
  }

}
